module.exports = __webpack_public_path__ + "static/img/图层61.709358e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层61.png
// module id = MTnI
// module chunks = 0